import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

import Btn from "../../Btn";

export const Ended = ({ linkDocument }) => {

    return (
        <div className = 'ended-voting__wrap'>
            <div className = 'ended-voting__info'>
                <h3 className = 'ended-voting__title'>Голосування завершено!</h3>
                <p className = 'ended-voting__text'>Ви можете подивитися результати голосування за посиланням</p>
            </div>
            <div className = 'ended-voting__btn'>
                {Boolean(linkDocument) &&
                <Btn
                    full
                    theme = 'blackinwhite'
                    title = 'Дивитись результати'
                    url = { linkDocument }
                />
                }
            </div>
        </div>
    );
};

Ended.propTypes = {
    linkDocument: PropTypes.string,
};
